import { DRYawnFreetrial, DRYawnFullBody, DRYawnTitle, iphoneMockup, logo } from "../../Assets/images";
import { Tick } from "../../Assets/svg";
import ListItem from "./List";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Promo = ({ handleContinue }) => {
    const { t } = useTranslation();
    const benefitsFromTranslation = t("promo.default.benefits", { returnObjects: true });
    const benefits = Array.isArray(benefitsFromTranslation) ? benefitsFromTranslation : [];

    return (
        <>
            <style>
                {`body {
                overflow: hidden;
                height: 100vh;
            } #root{ height: 100% }`}
            </style>
            <div className="promo-classes fullPageBg d-flex flex-column align-items-center gap-0 h-100 py-3 overflow-auto">
                <div className="d-flex align-items-center justify-content-between w-100 px-5 py-3">
                    <img src={logo} alt="Logo Horizontal" style={{ maxWidth: 120 }} className="img-fluid w-100" />
                    <Link to={'https://relaxscofa.com/dr-yawn-bio/'} target="_blank" rel="noopener noreferrer">
                        <img src={DRYawnTitle} alt="Logo" style={{ maxWidth: 115 }} className="img-fluid w-100" />
                    </Link>
                </div>
                <br />
                <div className="container-lg mb-2 mt-4">
                    <div className="row ">
                        <div className="col-12 text-center">
                            <p className="membership-title text-center w-100">{t("promo.default.title")}</p>
                            {/* <p className="membership-sub-title w-100 mb-0">{t("promo.default.subtitleLine1")} <br /> </p>
                            <p className="membership-sub-title w-100 px-5 px-lg-0 mb-0">
                                {t("promo.default.subtitleLine2")}  <br className="d-md-none" />{t("promo.default.subtitleLine3")}
                            </p> */}
                        </div>
                    </div>
                </div>
                <div className='container-lg membership-container mb-5 mb-sm-0'>
                    <div className="row ms-lg-4">
                        <div className="col-md-6 ms-xl-3  ml-md-0">
                            <div className="d-flex justify-content-center justify-content-md-end align-items-center" style={{ height: '100%' }}>
                                <img src={iphoneMockup} alt="iPhone Mockup" className="img-fluid membership-image" />
                            </div>
                        </div>
                        <div className="col-md-6  col-xl-5 align-self-center mt-0 mt-sm-0 ">
                            <div className="row mb-4 mt-md-0">
                                <div className="col-8 col-md-12 col-xl-12 mx-auto">
                                    <h5 className="membership-title my-2 text-center text-md-start text-nowrap">{t("promo.default.supportMessage")}</h5>
                                    <div className="ps-md-0 align-list-box ">
                                        <ListItem icon={Tick} data={benefits} />
                                    </div>
                                </div>
                            </div>
                            <div className="row" >
                                <div className="col-12 col-md-12 mx-auto">
                                    <div className="text-center">
                                        <p className="text-line-height-1 text-center text-md-start mb-2">{t("promo.default.ctaHeadline")}</p>
                                        <p className="text-line-height-2 text-center text-md-start fw-light mb-3">
                                            {t("promo.default.ctaSubheadlineDesktop")} <br className="d-lg-none" /> {t("promo.default.ctaSubheadlineMobile")}
                                        </p>
                                        <div className="d-flex align-items-end justify-content-center justify-content-md-start mt-0">
                                            <button className="primaryButton customButton stop-color py-3" style={{ backgroundColor: '#EFB729', fontSize: '12px', border: 'none' }} onClick={() => handleContinue()}>
                                                {t("promo.shared.continue")}
                                            </button>
                                        </div>
                                        <p className="py-4 mt-1 trial-list-item-text text-center text-lg-start d-none d-md-block">
                                            {t("promo.default.subAccountNote")}
                                        </p>
                                        <p className="py-4 mt-1 trial-list-item-text text-center text-lg-start d-block d-md-none" style={{ fontSize: '12px' }}>
                                            {t("promo.default.subAccountNote")}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="dr-yawn-freetrial-img-container">
                        <img src={DRYawnFullBody} alt="Logo" className="img-fluid w-100" />
                        <div className="dr-yawn-freetrial-content dr-yawn-content-text">
                            <img src={DRYawnTitle} alt="Logo" style={{maxWidth: 75}} className="img-fluid w-100" />
                            {/* <h4>Dr. Yawn</h4> */}
                            <span style={{ opacity: 0 }}>Scofa Mascot</span>
                        </div>
                    </div>
                    <br />
                    <br />
                </div>
            </div>
        </>
    );
};

export default Promo;
